import React, { useState, useEffect } from "react";
import "./NewDetectionConfig.scss";
import ProjectServices from "../../services/api/ProjectServices";
import VesselServices from "../../services/api/VesselServices";
import DeviceServices from "../../services/api/DeviceServices";
import { useAuthContext } from "../../dataproviders/AuthDataProvider";
import { useDetectionContext } from "../../dataproviders/DetectionDataProvider";

function NewDetectionConfig() {
    const authContext = useAuthContext();
    const detectionContext = useDetectionContext();

    const [projects, setProjects] = useState([]);
    const [vessels, setVessels] = useState([]);
    const [devices, setDevices] = useState([]);

    const [configData, setConfigData] = useState({
        projectid: '',
        vesselid: '',
        deviceid: ''
    });

    const [validationErrors, setValidationErrors] = useState({
        projectid: '',
        vesselid: '',
        deviceid: ''
    });

    const [showDropdown, setShowDropdown] = useState({
        projectid: false,
        vesselid: false,
        deviceid: false
    });

    const [selectedOpt, setSelectedOpt] = useState({
        projectid: '',
        vesselid: '',
        deviceid: ''
    });

    const [selectedDesc, setSelectedDesc] = useState({
        projectid: '',
        vesselid: '',
        deviceid: ''
    });

    const toggleDropdownProjectId = () => {
        setShowDropdown((prev) => ({
            ...prev,
            projectid: !showDropdown.projectid,
            vesselid: false,
            deviceid: false
        }));
    };

    const toggleDropdownVesselId = () => {
        setShowDropdown((prev) => ({
            ...prev,
            projectid: false,
            vesselid: !showDropdown.vesselid,
            deviceid: false
        }));
    };

    const toggleDropdownDeviceId = () => {
        setShowDropdown((prev) => ({
            ...prev,
            projectid: false,
            vesselid: false,
            deviceid: !showDropdown.deviceid
        }));
    };

    const handleOptionClick = (option, name, type) => {
        if (type === 'projectid') {
            setConfigData((prev) => ({
                ...prev,
                projectid: option,
                vesselid: '',
                deviceid: ''
            }));

            setValidationErrors((prev) => ({
                ...prev,
                projectid: '',
                vesselid: '',
                deviceid: ''
            }));

            setSelectedOpt((prev) => ({
                ...prev,
                projectid: option,
                vesselid: '',
                deviceid: ''
            }));

            setSelectedDesc((prev) => ({
                ...prev,
                projectid: name,
                vesselid: '',
                deviceid: ''
            }));

            setShowDropdown((prev) => ({
                ...prev,
                projectid: false,
                vesselid: false,
                deviceid: false
            }));

            setVessels([]);
            setDevices([]);
        }
        else if (type === 'vesselid') {
            setConfigData((prev) => ({
                ...prev,
                vesselid: option,
                deviceid: ''
            }));

            setValidationErrors((prev) => ({
                ...prev,
                vesselid: '',
                deviceid: ''
            }));

            setSelectedOpt((prev) => ({
                ...prev,
                vesselid: option,
                deviceid: ''
            }));

            setSelectedDesc((prev) => ({
                ...prev,
                vesselid: name,
                deviceid: ''
            }));

            setShowDropdown((prev) => ({
                ...prev,
                vesselid: false,
                deviceid: false
            }));

            setDevices([]);
        }
        else { //deviceid
            setConfigData((prev) => ({
                ...prev,
                deviceid: option,
            }));

            setValidationErrors((prev) => ({
                ...prev,
                deviceid: '',
            }));

            setSelectedOpt((prev) => ({
                ...prev,
                deviceid: option
            }));

            setSelectedDesc((prev) => ({
                ...prev,
                deviceid: name
            }));

            setShowDropdown((prev) => ({
                ...prev,
                deviceid: false
            }));
        }
    };

    const isOptionSelected = (option, type) => {
        if (type === 'projectid') {
            return option === selectedOpt.projectid ? 'selected' : '';
        }
        else if (type === 'vesselid') {
            return option === selectedOpt.vesselid ? 'selected' : '';
        }
        else { //deviceid
            return option === selectedOpt.deviceid ? 'selected' : '';
        }
    };

    const renderSelectTag = (option, type) => {
        if (type === 'projectid') {
            if (option === selectedOpt.projectid) {
                return (
                    <span className="select-tag float-right">
                        <i className="fa-solid fa-check "></i>
                    </span>
                );
            }
        }
        else if (type === 'vesselid') {
            if (option === selectedOpt.vesselid) {
                return (
                    <span className="select-tag float-right">
                        <i className="fa-solid fa-check "></i>
                    </span>
                );
            }
        }
        else { //deviceid
            if (option === selectedOpt.deviceid) {
                return (
                    <span className="select-tag float-right">
                        <i className="fa-solid fa-check "></i>
                    </span>
                );
            }
        }

        return (
            <span className="select-tag">
            </span>
        );
    };

    const handleSaveConfig = (e) => {

        //clear dropdown
        setShowDropdown({
            projectid: false,
            vesselid: false,
            deviceid: false
        });

        const errors = {};

        if (!configData.projectid) {
            errors.projectid = 'Project is required.';
        }

        if (!configData.vesselid) {
            errors.vesselid = 'Vessel is required.';
        }

        if (!configData.deviceid) {
            errors.deviceid = 'Device is required.';
        }

        setValidationErrors(errors);

        if (Object.keys(errors).length === 0) {
            //Send data to server
            saveConfig(configData);
        }
    };

    const saveConfig = async (configData) => {
        const cancelButton = document.getElementById("btnSaveConfig");

        try {
            // Disable the button and add the loading class
            cancelButton.disabled = true;
            cancelButton.innerHTML = '';
            cancelButton.classList.add('loading');

            let newConfigData = configData;
            newConfigData.projectname = selectedDesc.projectid;
            newConfigData.vesselname = selectedDesc.vesselid;
            newConfigData.devicename = selectedDesc.deviceid;

            detectionContext.SetDetectionConfig(newConfigData);

            handleCancel();
        }
        catch (error) {
            // Display error message for network errors
            handleError('Error', 'An error occurred. Please try again later.');
        }
        finally {
            // Enable the button and remove the loading class
            cancelButton.disabled = false;
            cancelButton.innerHTML = 'Yes';
            cancelButton.classList.remove('loading');
        }
    };

    const handleCancel = () => {
        resetForm();

        detectionContext.SetShowDetectionConfigPopup(false);
    };

    const handleError = (errorType, errorMessage) => {
        authContext.HandleError(errorType, errorMessage);
    }

    const resetForm = () => {
        setConfigData({
            projectid: '',
            vesselid: '',
            deviceid: ''
        });

        setValidationErrors({
            projectid: '',
            vesselid: '',
            deviceid: ''
        });

        setSelectedOpt({
            projectid: '',
            vesselid: '',
            deviceid: ''
        });

        setSelectedDesc({
            projectid: '',
            vesselid: '',
            deviceid: ''
        });

        setShowDropdown({
            projectid: false,
            vesselid: false,
            deviceid: false
        });

        setVessels([]);
        setDevices([]);
    }

    const getProjects = async () => {
        const result = await ProjectServices.GetProjectSets();
        if (!!result) {
            setProjects(result.data);

            setConfigData({
                projectid: '',
                vesselid: '',
                deviceid: ''
            });

            setValidationErrors({
                projectid: '',
                vesselid: '',
                deviceid: ''
            });

            setSelectedOpt({
                projectid: '',
                vesselid: '',
                deviceid: ''
            });

            setSelectedDesc({
                projectid: '',
                vesselid: '',
                deviceid: ''
            });

            setShowDropdown({
                projectid: false,
                vesselid: false,
                deviceid: false
            });

            setVessels([]);
            setDevices([]);
        }
    };

    const getVesselsByProjectId = async (projectId) => {
        const result = await VesselServices.GetVesselsByProjectId(projectId);
        if (!!result) {
            setVessels(result.data);

            setConfigData((prev) => ({
                ...prev,
                vesselid: '',
            }));

            setValidationErrors((prev) => ({
                ...prev,
                vesselid: '',
            }));

            setSelectedOpt((prev) => ({
                ...prev,
                vesselid: ''
            }));

            setSelectedDesc((prev) => ({
                ...prev,
                vesselid: ''
            }));

            setShowDropdown((prev) => ({
                ...prev,
                vesselid: false
            }));
        }
    };

    const getDevicesByVesselId = async (vesselid) => {
        const result = await DeviceServices.GetDevicesByVesselId(vesselid);
        if (!!result) {
            setDevices(result.data);

            setConfigData((prev) => ({
                ...prev,
                deviceid: '',
            }));

            setValidationErrors((prev) => ({
                ...prev,
                deviceid: '',
            }));

            setSelectedOpt((prev) => ({
                ...prev,
                deviceid: ''
            }));

            setSelectedDesc((prev) => ({
                ...prev,
                deviceid: ''
            }));

            setShowDropdown((prev) => ({
                ...prev,
                deviceid: false
            }));
        }
    };

    useEffect(() => {
        async function fetchData(vesselid) {
            await getDevicesByVesselId(vesselid);
        }
        if (selectedOpt.vesselid) {
            //Get device lists
            fetchData(selectedOpt.vesselid);
        }
    }, [selectedOpt.vesselid]);

    useEffect(() => {
        async function fetchData(projectid) {
            await getVesselsByProjectId(projectid);
        }
        if (selectedOpt.projectid) {
            //Get vessel lists
            fetchData(selectedOpt.projectid);
        }
    }, [selectedOpt.projectid]);

    useEffect(() => {
        async function fetchData() {
            await getProjects();
        }

        if (detectionContext.ShowDetectionConfigPopup) {
            //Get vessel lists
            fetchData();
        }

    }, [detectionContext.ShowDetectionConfigPopup]);

    return (
        <>
            {detectionContext.ShowDetectionConfigPopup &&
                <div className="dialog-overlay dialog-overlay-fit">
                    <div className="dialog-container dialog-container-long">
                        {(!(detectionContext.DetectionConfig.projectid === '' || detectionContext.DetectionConfig.vesselid === '' || detectionContext.DetectionConfig.deviceid === '')) &&
                            <button
                                className="dialog-close-button"
                                onClick={handleCancel}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        }
                        <p className="dialog-title col-rps-light mt-0 mb-0">Event Settings</p>
                        <div className="dialog-content">
                            <div className="mb-2">
                                <div className="position-relative d-flex align-items-center input-label-group">
                                    <label htmlFor="ddlProjectId" className="w-30 required">Projects</label>
                                    <button id="ddlProjectId" className={`btn-dropdown w-70 ${validationErrors.projectid ? 'dropdown-error' : ''} ${showDropdown.projectid ? 'btn-dropdown-expanded' : ''}`} onClick={toggleDropdownProjectId}>
                                        <span id="ddlSelectedOptProjectId" className="btn-dropdown-text float-left">{selectedDesc.projectid}</span>
                                        <span className={`btn-dropdown-direction float-right ${showDropdown.projectid ? 'col-rps' : ''}`}><i className={`fa-solid fa-chevron-down`}></i></span>
                                    </button>
                                    <div className={`dropdown-content dropdown-content-project-link ${showDropdown.projectid ? 'd-block' : 'd-none'}`}>
                                        {projects.map(option => (
                                            <div key={`projectid-${option.projectid}`} className={`dropdown-content-link ${isOptionSelected(option.projectid, 'projectid')}`} onClick={() => handleOptionClick(option.projectid, option.projectname, 'projectid')}><span>{option.projectname} ({option.status})</span>{renderSelectTag(option.projectid, 'projectid')}</div>
                                        ))}
                                    </div>
                                </div>
                                {validationErrors.projectid && (
                                    <label className="error error-message">
                                        <i className="fa-solid fa-circle-info"></i> {validationErrors.projectid}
                                    </label>
                                )}
                            </div>
                            <div className="mb-2">
                                <div className="position-relative d-flex align-items-center input-label-group">
                                    <label htmlFor="ddlVesselId" className="w-30 required">Vessel</label>
                                    <button id="ddlVesselId" disabled={!(vessels && vessels.length > 0)} className={`btn-dropdown w-70 ${validationErrors.vesselid ? 'dropdown-error' : ''} ${showDropdown.vesselid ? 'btn-dropdown-expanded' : ''}`} onClick={toggleDropdownVesselId}>
                                        <span id="ddlSelectedOptVesselId" className="btn-dropdown-text float-left">{selectedDesc.vesselid}</span>
                                        <span className={`btn-dropdown-direction float-right ${showDropdown.vesselid ? 'col-rps' : ''}`}><i className={`fa-solid fa-chevron-down`}></i></span>
                                    </button>
                                    <div className={`dropdown-content dropdown-content-vessel-link ${showDropdown.vesselid ? 'd-block' : 'd-none'}`}>
                                        {vessels.map(option => (
                                            <div key={`vesselid-${option.vesselid}`}
                                                className={`dropdown-content-link ${isOptionSelected(option.vesselid, 'vesselid')} ${(!option.status || option.status !== 1) ? 'disabled' : ''}`}
                                                onClick={() => {
                                                    if (option.status && option.status === 1) {
                                                        handleOptionClick(option.vesselid, option.vesselname, 'vesselid');
                                                    }
                                                }}
                                            >
                                                <span>{option.vesselname}</span>
                                                {(!option.status || option.status !== 1) && (
                                                    <span className="tooltip-text">Vessel is currently disabled.</span>
                                                )}
                                                {renderSelectTag(option.vesselid, 'vesselid')}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                {validationErrors.vesselid && (
                                    <label className="error error-message">
                                        <i className="fa-solid fa-circle-info"></i> {validationErrors.vesselid}
                                    </label>
                                )}
                            </div>
                            <div className="mb-2">
                                <div className="position-relative d-flex align-items-center input-label-group">
                                    <label htmlFor="ddlDeviceId" className="w-30 required">Device</label>
                                    <button id="ddlDeviceId" disabled={!(devices && devices.length > 0)} className={`btn-dropdown w-70 ${validationErrors.deviceid ? 'dropdown-error' : ''} ${showDropdown.deviceid ? 'btn-dropdown-expanded' : ''}`} onClick={toggleDropdownDeviceId}>
                                        <span id="ddlSelectedOptDeviceId" className="btn-dropdown-text float-left">{selectedDesc.deviceid}</span>
                                        <span className={`btn-dropdown-direction float-right ${showDropdown.deviceid ? 'col-rps' : ''}`}><i className={`fa-solid fa-chevron-down`}></i></span>
                                    </button>
                                    <div className={`dropdown-content dropdown-content-device-link ${showDropdown.deviceid ? 'd-block' : 'd-none'}`}>
                                        {devices.map(option => (
                                            <div key={`deviceid-${option.deviceid}`}
                                                className={`dropdown-content-link ${isOptionSelected(option.deviceid, 'deviceid')} ${(!option.containername || option.containername.trim() === '') ? 'disabled' : ''}`}
                                                onClick={() => {
                                                    if (option.containername && option.containername.trim() !== '') {
                                                        handleOptionClick(option.deviceid, option.devicename, 'deviceid');
                                                    }
                                                }}
                                            >
                                                <span>{option.devicename}</span>
                                                {(!option.containername || option.containername.trim() === '') && (
                                                    <span className="tooltip-text">No storage container linked.</span>
                                                )}
                                                {renderSelectTag(option.deviceid, 'deviceid')}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                {validationErrors.deviceid && (
                                    <label className="error error-message">
                                        <i className="fa-solid fa-circle-info"></i> {validationErrors.deviceid}
                                    </label>
                                )}
                            </div>
                        </div>
                        <div className="dialog-buttons float-right">
                            <button id="btnSaveConfig" className="btn btn-dialog btn-primary btn-me" onClick={handleSaveConfig}>Save</button>
                            <button
                                className="btn btn-dialog btn-secondary"
                                disabled={detectionContext.DetectionConfig.projectid === '' || detectionContext.DetectionConfig.vesselid === '' || detectionContext.DetectionConfig.deviceid === ''}
                                onClick={handleCancel}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

export default NewDetectionConfig;
